import { render, staticRenderFns } from "./ContentRiskModal.vue?vue&type=template&id=d45aac5c&scoped=true"
import script from "./ContentRiskModal.vue?vue&type=script&lang=js"
export * from "./ContentRiskModal.vue?vue&type=script&lang=js"
import style0 from "./ContentRiskModal.vue?vue&type=style&index=0&id=d45aac5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d45aac5c",
  null
  
)

export default component.exports